import { compose } from 'lodash/fp'
import { darken, desaturate, lighten, rem } from 'polished'
import { BASE_FONT_SIZE } from './constants'

export const pxToRem = (pxUnit: number, base = BASE_FONT_SIZE) => rem(pxUnit, base)
export const remToPx = (remUnit: number, base = BASE_FONT_SIZE) => remUnit * Number.parseFloat(base)

export const getHoverColor = compose(desaturate(0.2), darken(0.1))
export const getDisabledColor = lighten(0.1)
